import { Component } from "@angular/core";

@Component({
  selector: "brd-navbar-footer",
  templateUrl: "./navbar-footer.component.html",
  styleUrl: "./navbar-footer.component.less",
  standalone: false
})
export class NavbarFooterComponent {
  pages = [
    { text: "Home", link: "/" },
    { text: "News", link: "/news" },
    { text: "About", link: "/about" },
    { text: "Support", link: "/support" },
    { text: "Faq", link: "/faq" }
  ];
}
